import { createContext, useCallback, useContext, useMemo, useState } from "react";

const QuizContext = createContext(null);

export function QuizProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [source, setSource] = useState("website");
  const [fitScore, setFitScore] = useState(null);

  const openQuiz = useCallback((from = "website") => { setSource(from); setOpen(true); }, []);
  const closeQuiz = useCallback(() => setOpen(false), []);
  const [fitSignals, setFitSignals] = useState(null);

  const value = useMemo(() => ({ open, source, fitScore, setFitScore, fitSignals, setFitSignals, openQuiz, closeQuiz }), [open, source, fitScore, fitSignals, openQuiz, closeQuiz]);
  return <QuizContext.Provider value={value}>{children}</QuizContext.Provider>;
}

export const useQuiz = () => useContext(QuizContext);
